package com.patronat.top.features.dashboard.presentation.reviewmoderation

import com.patronat.top.core.base.ViewEvent
import com.patronat.top.core.base.ViewSideEffect
import com.patronat.top.core.base.ViewState
import com.patronat.top.dto.ReviewResponse
import com.patronat.top.dto.ReviewStatus

enum class ReviewModerationStatusFilterPreset(
    val id: String,
    val backendStatus: ReviewStatus
) {
    NEW("new", ReviewStatus.ON_MODERATION),
    PUBLISHED("published", ReviewStatus.PUBLISHED),
    REJECTED("rejected", ReviewStatus.REJECTED);

    companion object {
        fun fromId(id: String): ReviewModerationStatusFilterPreset? = entries.firstOrNull { it.id == id }
    }
}

data class ReviewAiModerationState(
    val reviews: List<ReviewResponse> = emptyList(),
    val venueNamesById: Map<String, String> = emptyMap(),
    val failedVenueIds: Set<String> = emptySet(),
    val totalCount: Long = 0,
    val currentPage: Int = 1,
    val pageSize: Int = 20,
    val isLoading: Boolean = true,
    val actionReviewId: String? = null,
    val searchQuery: String = "",
    val selectedStatusFilterIds: List<String> = listOf(ReviewModerationStatusFilterPreset.NEW.id),
    val error: String? = null
) : ViewState {
    val isEmpty: Boolean
        get() = reviews.isEmpty() && !isLoading && error == null
}

sealed interface ReviewAiModerationEvent : ViewEvent {
    data object Initialize : ReviewAiModerationEvent
    data object OnReload : ReviewAiModerationEvent
    data class OnSearchChanged(val query: String) : ReviewAiModerationEvent
    data class OnStatusFilterChanged(val filterIds: List<String>) : ReviewAiModerationEvent
    data class OnPageChanged(val page: Int) : ReviewAiModerationEvent
    data class OnPageSizeChanged(val pageSize: Int) : ReviewAiModerationEvent
    data class OnApproveClicked(val reviewId: String) : ReviewAiModerationEvent
    data class OnRejectClicked(val reviewId: String) : ReviewAiModerationEvent
}

sealed interface ReviewAiModerationEffect : ViewSideEffect
